import type { AxiosInstance } from 'axios'

import {
  CategoryDetailInterface,
  UpdateCategoryInputInterface
} from '../../interfaces/category'

export const updateCategory = (api: AxiosInstance) => (
  categoryId: string,
  categoryDetail: UpdateCategoryInputInterface
): Promise<CategoryDetailInterface> =>
  api.put(`/v1.0/admin/categories/${categoryId}`, categoryDetail)
